import { DashboardWidgetDto } from './Dashboard';
import { ProjectFileSystemStructureId } from './Types';

export interface ContactClassification {
  contactClassificationId: string;
  name: string;
  description: string;
  isArchived: boolean;
  rowVersion: string;
}

export interface CompanyClassification {
  companyClassificationId: string;
  name: string;
  description: string;
  isArchived: boolean;
  rowVersion: string;
}

export interface ProjectFileSystemStructure {
  projectFileSystemStructureId: ProjectFileSystemStructureId;
  name: string;
  isActive: boolean;
  folderStructureJson: FolderStructure;
}

export interface CreateProjectFileSystemStructure {
  name: string;
  isActive: boolean;
  folderStructureJson: FolderStructure;
}

export interface FolderStructure {
  folders: FileSystemStructureFolder[];
}

export type ChannelMembershipType = 'standard' | 'private';

export interface FileSystemStructureFolder {
  name: string;
  tags: string[];
  subFolders?: FileSystemStructureFolder[];
  totalSubfolderCount: number;
  description?: string;
  isTeamsChannel: boolean;
  channelMembershipType?: ChannelMembershipType;
  folderPermission?: FolderPermission[];
}

export interface FolderPermission {
  accessRight: FolderPermissionAccessRight;
  roles: FolderPermissionRole[];
}

export interface FolderPermissionV2 {
  accessRights: FolderPermissionAccessRight;
  canRead: boolean;
  canWrite: boolean;
}

export type FolderPermissionAccessRight =
  | 'admin'
  | 'assistance'
  | 'member'
  | 'controller'
  | 'guest';
export type FolderPermissionRole = 'read' | 'write' | 'none';

export const ESettingScope = {
  NONE: 'none',
  GLOBAL: 'global',
  OFFICE: 'office',
  PROJECT: 'project',
  PROJECTEXTENSION: 'projectExtension',
  USER: 'user',
} as const;
export type ESettingScopeType =
  (typeof ESettingScope)[keyof typeof ESettingScope];

export interface Setting {
  settingId: string;
  key: string;
  jsonValue: string;
  parentSettingId: string;
  relationId: string;
  scope: ESettingScopeType;
  scopeId: string;
  isDefault: boolean;
  couldNotBeLoadedReason: string;
  couldNotBeLoaded: boolean;
}

export interface UpdateSetting {
  jsonValue: string;
  parentSettingId: string;
  relationId: string;
  isDefault: boolean;
  description: string;
}

export interface CreateSetting extends UpdateSetting {}

export interface SettingKey {
  scopeId: string;
  eSettingScope: SettingScope;
  relationId?: string;
  keys: string[];
}

export type SettingScope =
  | 'none'
  | 'global'
  | 'office'
  | 'project'
  | 'projectExtension'
  | 'user';

export interface OpenExperienceSettings {
  enabledServices: OpenExperienceService[];
  duplicateProjectId: string;
  syncExternalContactsAsContractors: boolean;
}

export enum OpenExperienceService {
  Oa = 'oa',
  Fd2 = 'fd2',
  Qm = 'qm',
  Ot2 = 'ot2',
}

export interface DefaultDashboardSetting {
  dashboard: {
    dashboardType: 'me' | 'project';
    belongsToUserId: '00000000-0000-0000-0000-000000000000'; //empty guid string;
    isShared: boolean;
    isFavorite: boolean;
    dashboardName: string;
    dashboardDescription: string;
    dashboardId: '00000000-0000-0000-0000-000000000000';
    widgets: DashboardWidgetDto[];
  };
}
